import React from 'react';

const SvgBell = props => (
  <svg
    id="bell_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <style>{'.bell_svg__cls-1{fill:#999}'}</style>
    </defs>
    <g id="bell_svg__bell">
      <path
        className="bell_svg__cls-1"
        d="M18.77 16.52H5.23a.76.76 0 01-.42-1.38S6.74 13.71 6.74 9a5.27 5.27 0 1110.53 0c0 4.72 1.91 6.14 1.93 6.15a.76.76 0 01-.43 1.38zM6.84 15h10.32a11.41 11.41 0 01-1.4-6 3.76 3.76 0 10-7.52 0 11.41 11.41 0 01-1.4 6z"
        id="bell_svg__Path"
      />
      <path
        className="bell_svg__cls-1"
        d="M12 20.28a2.29 2.29 0 01-1.95-1.13.75.75 0 01.28-1 .74.74 0 011 .27.78.78 0 001.3 0 .75.75 0 011-.27.76.76 0 01.28 1A2.31 2.31 0 0112 20.28z"
        id="bell_svg__Path-2"
      />
    </g>
  </svg>
);

export default SvgBell;
